module.exports = __webpack_public_path__ + "static/mobx-dc16cedcf75e34fe6501cc0791f4c6ae.png";